/**
 * Header Component
 */

import React, { FC } from 'react';
import { OverlayProps } from '../animatedModal.types';
import { Wrapper } from './overlay.style';
import ScrollLock from '../../ScrollLock/scrollLock';

const Overlay: FC<OverlayProps> = ({
  open,
  showOverlay,
  color,
  opacity,
  onClickHandler,
  portalTarget,
  animationDuration,
  animateOut,
}: OverlayProps) => {

  return (
      <>
        {open && <ScrollLock element={portalTarget} />}
        <Wrapper
          onClick={onClickHandler}
          showOverlay={showOverlay}
          opacity={opacity}
          color={color}
          animationDuration={animationDuration}
          animateOut={animateOut}
        />
      </>
  );

};

export default Overlay;
